import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    success: {
      main: '#4caf50', // Green for excellent scores >= 3.5
    },
    warning: {
      main: '#ff9800', // Orange for good scores >= 2.0
    },
    error: {
      main: '#f44336', // Red for needs improvement scores < 2.0
    },
  },
});

export default theme;